

function ___$insertStyle(css) {
    if (!css || !window) {
        return;
    }
    const style = document.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    document.head.appendChild(style);
    return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var lodash = require('lodash');
var reactStripeJs = require('@stripe/react-stripe-js');
var stripeJs = require('@stripe/stripe-js');
var qs = require('qs');

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var StripeCustomerAssociation;
(function (StripeCustomerAssociation) {
    StripeCustomerAssociation["Subscriptions"] = "subscriptions";
    StripeCustomerAssociation["Cards"] = "cards";
})(StripeCustomerAssociation || (StripeCustomerAssociation = {}));
var StripeCustomerExpand;
(function (StripeCustomerExpand) {
    StripeCustomerExpand["DefaultSource"] = "default_source";
    StripeCustomerExpand["InvoiceSettingsDefaultPaymentMethod"] = "invoice_settings.default_payment_method";
})(StripeCustomerExpand || (StripeCustomerExpand = {}));
var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["Active"] = "active";
    SubscriptionStatus["Trialing"] = "trialing";
    SubscriptionStatus["Incomplete"] = "incomplete";
    SubscriptionStatus["IncompleteExpired"] = "incomplete_expired";
    SubscriptionStatus["PastDue"] = "past_due";
    SubscriptionStatus["Canceled"] = "canceled";
    SubscriptionStatus["Unpaid"] = "unpaid";
})(SubscriptionStatus || (SubscriptionStatus = {}));

var _a, _b;
var URLS = {
    PRICING: "https://api.priceblocs.com" + "/v1/config/pricing",
    CHECKOUT: "https://api.priceblocs.com" + "/v1/config/checkout",
    INVOICE_PREVIEW: "https://api.priceblocs.com" + "/v1/config/invoice/preview",
    SUBSCRIPTIONS: "https://api.priceblocs.com" + "/v1/config/subscriptions",
    BILLING: "https://api.priceblocs.com" + "/v1/config/billing",
    USAGE: "https://api.priceblocs.com" + "/v1/config/usage"
};
var POST = 'POST';
var GET = 'GET';
var PUT = 'PUT';
var DELETE = 'DELETE';
var METHODS = {
    POST: POST,
    GET: GET,
    PUT: PUT,
    DELETE: DELETE
};
var DAY = 'day';
var WEEK = 'week';
var MONTH = 'month';
var YEAR = 'year';
var RECURRING_INTERVALS = {
    DAY: DAY,
    WEEK: WEEK,
    MONTH: MONTH,
    YEAR: YEAR
};
var INTERVAL_LABELS_MAP = (_a = {
        one_time: 'once'
    },
    _a[RECURRING_INTERVALS.DAY] = 'daily',
    _a[RECURRING_INTERVALS.WEEK] = 'weekly',
    _a[RECURRING_INTERVALS.MONTH] = 'monthly',
    _a[RECURRING_INTERVALS.YEAR] = 'yearly',
    _a);
var INTERVAL_SHORTHAND_MAP = (_b = {},
    _b[RECURRING_INTERVALS.DAY] = 'day',
    _b[RECURRING_INTERVALS.WEEK] = 'wk',
    _b[RECURRING_INTERVALS.MONTH] = 'mo',
    _b[RECURRING_INTERVALS.YEAR] = 'mo',
    _b);
var SESSION_FIELDS = [
    'shipping_worldwide',
    'success_url',
    'cancel_url',
    'payment_method_types',
    'discounts',
    'allow_promotion_codes',
    'billing_address_collection',
    'shipping_address_collection',
    'submit_type',
    'consent_collection',
    'after_expiration',
    'expires_at',
    'adjustable_quantity',
    'tax_rates',
    'dynamic_tax_rates',
    'automatic_tax',
    'client_reference_id',
    'tax_id_collection',
    'shipping_options',
    'payment_intent_data',
    'trial_period_days',
    'trial_end',
    'customer',
    'customer_email',
    'metadata',
];
var CONFIG_FIELDS = [
    'id',
    'prices',
    'sessions',
    'query',
    'presentation',
    'entitlements',
    'features',
    'contactless',
];
/**
 * TODO: need to enable spread operator for ts
 */
SESSION_FIELDS.forEach(function (field) { return CONFIG_FIELDS.push(field); });
var CONFIG_DEFAULTS = {
    debug: false,
    fetch: {
        on_mount: true,
        on_customer_change: true
    }
};

var getActiveProductPrice = function (product, _a) {
    var currency = _a.currency, interval = _a.interval;
    return product.prices.find(function (price) {
        var match = false;
        var currencyMatch = price.currency === currency;
        var intervalMatch = Boolean(price.recurring && price.recurring.interval === interval);
        if (currency && interval) {
            match = currencyMatch && intervalMatch;
        }
        else if (currency) {
            match = currencyMatch;
        }
        else if (interval) {
            match = intervalMatch;
        }
        return match;
    });
};
var getSubscriptionItemForPrice = function (price, subscription) { return subscription.items.data.find(function (item) { return item.price.id === price; }); };
var getProductFeatures = function (productId, featureGroups, entitlementsConfig) {
    return featureGroups.reduce(function (memo, featureGroup) {
        featureGroup.features &&
            featureGroup.features.forEach(function (feature) {
                var enabled = entitlementsConfig &&
                    entitlementsConfig[feature.uid] &&
                    entitlementsConfig[feature.uid][productId] &&
                    entitlementsConfig[feature.uid][productId].enabled;
                if (enabled) {
                    memo.push(feature);
                }
            });
        return memo;
    }, []);
};
var getProductsFeaturesTable = function (_a) {
    var entitlementsConfig = _a.entitlementsConfig, products = _a.products, featureGroups = _a.featureGroups, _b = _a.featureKey, featureKey = _b === void 0 ? 'uid' : _b;
    return {
        header: products.map(function (_a) {
            var name = _a.name, id = _a.id;
            return ({
                id: id,
                title: name
            });
        }),
        groups: featureGroups.map(function (featureGroup) { return ({
            columns: products.reduce(function (memo, product) {
                memo.push({ accessor: product.id });
                return memo;
            }, [
                {
                    header: featureGroup.title,
                    accessor: 'title'
                },
            ]),
            rows: featureGroup.features.map(function (feature) {
                return __assign({ title: {
                        value: feature.title,
                        tooltip: feature.tooltip || null
                    } }, products.reduce(function (memo, product) {
                    var entitlement = entitlementsConfig &&
                        entitlementsConfig[feature[featureKey]] &&
                        entitlementsConfig[feature[featureKey]][product.id];
                    memo[product.id] = entitlement || null;
                    return memo;
                }, {}));
            })
        }); })
    };
};
var getGoodStandingSubscriptions = function (subscriptions) {
    return subscriptions.filter(function (_a) {
        var status = _a.status;
        return status === SubscriptionStatus.Active.toString() ||
            status === SubscriptionStatus.Trialing.toString();
    });
};
var getConfig = function (config) {
    return lodash.merge(CONFIG_DEFAULTS, config);
};

/**
 * Disable checkout
 * - If the count of subscribed prices is the same as the prices provided
 * - Then check if all prices have an active subscription
 * - Else set disabled false
 */
var getCheckoutDisabled = function (_a) {
    var subscriptions = _a.subscriptions, prices = _a.prices;
    var disabled = true;
    var subscribedPriceCount = 0;
    var activeSubPriceMap = subscriptions.reduce(function (memo, subscription) {
        subscription.items.data.forEach(function (_a) {
            var id = _a.price.id;
            if (!memo[id]) {
                subscribedPriceCount += 1;
                memo[id] = true;
            }
        });
        return memo;
    }, {});
    if (subscribedPriceCount === prices.length) {
        for (var priceIx = 0; priceIx < prices.length; priceIx++) {
            var alreadySubscribedToPrice = activeSubPriceMap[prices[priceIx]];
            if (!alreadySubscribedToPrice) {
                disabled = false;
                break;
            }
        }
    }
    else {
        disabled = false;
    }
    return disabled;
};

var _this = undefined;
var useActiveProductPrice = function (productId) {
    var values = usePriceBlocsContext().values;
    var product = values && values.products.find(function (_a) {
        var id = _a.id;
        return id === productId;
    });
    return (product &&
        getActiveProductPrice(product, {
            currency: values.form.currency,
            interval: values.form.interval
        }));
};
var useSubscriptionItemForPrice = function (price) {
    var values = usePriceBlocsContext().values;
    var subscription = values && values.customer && values.customer.subscriptions
        ? getGoodStandingSubscriptions(values.customer.subscriptions)[0]
        : null;
    return subscription ? getSubscriptionItemForPrice(price, subscription) : null;
};
var useGoodStandingSubscriptions = function () {
    var values = usePriceBlocsContext().values;
    return values && values.customer && values.customer.subscriptions
        ? getGoodStandingSubscriptions(values.customer.subscriptions)
        : [];
};
var useEntitlement = function (featureUid) {
    var values = usePriceBlocsContext().values;
    return values && values.entitlements && values.entitlements[featureUid]
        ? values.entitlements[featureUid]
        : { enabled: false };
};
var useFeature = function (featureUid) {
    var values = usePriceBlocsContext().values;
    var feature;
    if (values && values.featureGroups) {
        for (var featureGroupIx = 0; featureGroupIx < values.featureGroups.length; featureGroupIx++) {
            var group = values.featureGroups[featureGroupIx];
            feature = group.features.find(function (_a) {
                var uid = _a.uid;
                return uid === featureUid;
            });
            if (feature) {
                break;
            }
        }
    }
    return feature;
};
/**
 * - Usually we only want to allow a customer to subscribe to one price at a time
 * - To prevent subscription to duplicate prices we can check if all of the prices
 *  within current checkout cart are present in any of the active subscriptions
 * - If all checkout cart prices are also present in an active subscription then
 * Want to conditionally enable / disable checkout updates
 * If subscription present - will preview then update
 * Else will create a new one
 */
var useCheckoutCart = function (props) {
    var result = {
        previewable: false,
        subscriptions: [],
        checkout: { prices: [] },
        disabled: true
    };
    var values = usePriceBlocsContext().values;
    var customer = values && values.customer && values.customer;
    var items = values && values.form && values.form.checkout && values.form.checkout.items;
    /**
     * Price usage hierarchy
     * 1. prices provided via checkout props
     * 2. prices within context i.e. values.form.checkout.items
     */
    var checkoutPrices = items ? items.map(function (_a) {
        var id = _a.price.id;
        return id;
    }) : [];
    var prices = props && props.prices ? props.prices : checkoutPrices;
    result.checkout = {
        prices: prices
    };
    /**
     * Disable checkout if all prices are the same:
     * - price id count is same price ids in the cart are the same as the sub
     * If all of the current checkout cart prices are already subscribed to
     * then we disable checkout
     */
    var checkoutDisabled = false;
    var subscriptions = customer && customer.subscriptions && getGoodStandingSubscriptions
        ? getGoodStandingSubscriptions(customer.subscriptions)
        : [];
    result.subscriptions = subscriptions;
    var subsCount = result.subscriptions.length;
    var hasActiveSubs = subsCount > 0;
    result.previewable = hasActiveSubs;
    if (hasActiveSubs) {
        checkoutDisabled = getCheckoutDisabled({
            subscriptions: subscriptions,
            prices: prices
        });
    }
    var hasPrices = prices.length > 0;
    if (subsCount > 1) {
        console.warn('Multiple good standing subscriptions available for preview.');
    }
    result.disabled = checkoutDisabled || !hasPrices;
    return result;
};
var usePreviewInvoice = function (props) {
    var subscription = props.subscription, prices = props.prices;
    var _a = usePriceBlocsContext(), previewInvoice = _a.previewInvoice, values = _a.values;
    var _b = React.useState(null), data = _b[0], setData = _b[1];
    var _c = React.useState(null), previewed = _c[0], setPreviewed = _c[1];
    var _d = React.useState(false), loading = _d[0], setLoading = _d[1];
    var items = values && values.form && values.form.checkout && values.form.checkout.items;
    var itemPrices = React.useMemo(function () { return (Array.isArray(items) ? items.map(function (_a) {
        var id = _a.price.id;
        return id;
    }) : []); }, [items]);
    var previewItems = React.useMemo(function () { return (Array.isArray(prices) && prices.length > 0 ? prices : itemPrices); }, [prices, itemPrices]);
    var getPreview = React.useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var previewData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    if (!previewed) {
                        setPreviewed(true);
                    }
                    return [4 /*yield*/, previewInvoice({
                            items: previewItems,
                            subscription: subscription
                        })];
                case 1:
                    previewData = _a.sent();
                    setData(previewData);
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); }, [previewItems, subscription, previewInvoice]);
    React.useEffect(function () {
        if (!data && !loading && !previewed) {
            getPreview();
        }
    }, [data, loading, previewItems, subscription, getPreview, previewed]);
    return {
        getPreview: getPreview,
        data: data,
        loading: loading,
        setLoading: setLoading
    };
};

var getAuthHeaders = function (apiKey) { return ({
    'Content-Type': 'application/json',
    Authorization: "Bearer " + apiKey
}); };
var getCustomerParams = function (customer) {
    var result = {};
    if (customer.id) {
        result.customer = customer.id;
    }
    else if (customer.email) {
        result.customer_email = customer.email;
    }
    return result;
};
var getFetchConfigData = function (configProps) {
    var result = {};
    if (configProps.customer) {
        result.customer = configProps.customer;
    }
    else if (configProps.customer_email) {
        result.customer_email = configProps.customer_email;
    }
    else if (configProps.email) {
        result.email = configProps.email;
    }
    CONFIG_FIELDS.forEach(function (field) {
        var configVal = configProps[field];
        if (configVal) {
            result[field] = configVal;
        }
    });
    return result;
};
var ENCRYPTED_PREFIX_RE = /^Fe26/;
var isEncryptedValue = function (value) {
    return ENCRYPTED_PREFIX_RE.test(value);
};
var getCheckoutData = function (configProps, callProps) {
    var currentUrl = window.location.href;
    if (typeof callProps === 'string') {
        var result = {
            cancel_url: currentUrl
        };
        if (isEncryptedValue(callProps)) {
            result.sessionId = callProps;
        }
        else {
            result.prices = [callProps];
        }
        if (configProps.success_url) {
            result.success_url = configProps.success_url;
        }
        if (configProps.cancel_url) {
            result.cancel_url = configProps.cancel_url;
        }
        var returnUrl = configProps.return_url || currentUrl;
        if (returnUrl) {
            result.return_url = returnUrl;
        }
        if (configProps.customer) {
            var customer = getCustomerParams(configProps.customer);
            for (var key in customer) {
                result[key] = customer[key];
            }
        }
        return result;
    }
    else {
        var result_1 = {
            cancel_url: currentUrl
        };
        if (callProps.sessionId) {
            result_1.sessionId = callProps.sessionId;
        }
        else if (callProps.prices) {
            result_1.prices = callProps.prices;
        }
        else if (Array.isArray(callProps.line_items) &&
            callProps.line_items.length > 0) {
            result_1.line_items = callProps.line_items;
        }
        else {
            throw new Error('Insufficient checkout params passed. You must pass at least one price id, session id or one line_item');
        }
        if (configProps.metadata && configProps.metadata.id) {
            result_1.id = configProps.metadata.id;
        }
        /**
         * Extend with any defined session fields
         */
        SESSION_FIELDS.forEach(function (field) {
            var configVal = callProps[field];
            if (configVal) {
                result_1[field] = configVal;
            }
        });
        var successUrl = callProps.success_url || configProps.success_url;
        if (successUrl) {
            result_1.success_url = successUrl;
        }
        var cancelUrl = callProps.cancel_url || configProps.cancel_url;
        if (cancelUrl) {
            result_1.cancel_url = cancelUrl;
        }
        var returnUrl = callProps.return_url || configProps.return_url || currentUrl;
        if (returnUrl) {
            result_1.return_url = returnUrl;
        }
        var customerProp = callProps.customer || configProps.customer;
        if (customerProp) {
            var customer = getCustomerParams(customerProp);
            for (var key in customer) {
                result_1[key] = customer[key];
            }
        }
        return result_1;
    }
};
var getCallOrConfigCustomer = function (callProps, configProps) {
    var customer;
    if (callProps && callProps.customer) {
        customer = callProps.customer;
    }
    else if (configProps.customer && configProps.customer.id) {
        customer = configProps.customer.id;
    }
    if (!customer) {
        throw new Error('A valid customer must be provided to this action.');
    }
    return customer;
};
var getBillingData = function (configProps, callProps) {
    var customer = getCallOrConfigCustomer(callProps, configProps);
    return {
        customer: customer,
        return_url: callProps && callProps.return_url
            ? callProps.return_url
            : configProps.return_url || window.location.href
    };
};
var getReportUsageData = function (configProps, callProps) {
    var customer = getCallOrConfigCustomer(callProps, configProps);
    var result = {
        customer: customer,
        subscription_item: callProps.subscription_item
    };
    if (callProps.quantity) {
        result.quantity = callProps.quantity;
    }
    if (callProps.timestamp) {
        result.timestamp = callProps.timestamp;
    }
    if (callProps.action) {
        result.action = callProps.action;
    }
    return result;
};
var getFetchUsageData = function (configProps, callProps) {
    var customer = getCallOrConfigCustomer(callProps, configProps);
    var result = {
        customer: customer,
        subscription_item: callProps.subscription_item
    };
    return result;
};
var getPreviewInvoiceData = function (configProps, callProps) {
    var customer = getCallOrConfigCustomer(callProps, configProps);
    if (!callProps.subscription) {
        throw new Error('A valid subscription must be provided to preview an invoice.');
    }
    return {
        customer: customer,
        subscription: callProps.subscription,
        items: callProps.items || configProps.values.form.checkout.items || []
    };
};
var getUpdateSubscriptionData = function (configProps, callProps) {
    var customer = getCallOrConfigCustomer(callProps, configProps);
    if (!callProps.id) {
        throw new Error('A valid subscription must be provided to update.');
    }
    if (!callProps.items || !callProps.items.length) {
        throw new Error('Subscription items must be provided to update.');
    }
    var result = {
        id: callProps.id,
        customer: customer,
        items: callProps.items
    };
    if (callProps.proration_date) {
        result.proration_date = callProps.proration_date;
    }
    return result;
};

var _this$1 = undefined;
var fetchConfig = function (apiKey, data) { return __awaiter(_this$1, void 0, void 0, function () {
    var response, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch(URLS.PRICING, {
                    method: METHODS.POST,
                    headers: getAuthHeaders(apiKey),
                    body: JSON.stringify(data)
                })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2:
                result = _a.sent();
                if ('statusCode' in result && result.statusCode !== 200) {
                    throw result;
                }
                return [2 /*return*/, result];
        }
    });
}); };
var createSession = function (apiKey, data) { return __awaiter(_this$1, void 0, void 0, function () {
    var response, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch(URLS.CHECKOUT, {
                    method: METHODS.POST,
                    headers: getAuthHeaders(apiKey),
                    body: JSON.stringify(data)
                })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2:
                result = _a.sent();
                if ('statusCode' in result && result.statusCode !== 200) {
                    throw result;
                }
                return [2 /*return*/, result];
        }
    });
}); };
var createBilling = function (apiKey, data) { return __awaiter(_this$1, void 0, void 0, function () {
    var response, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch(URLS.BILLING, {
                    method: METHODS.POST,
                    headers: getAuthHeaders(apiKey),
                    body: JSON.stringify(data)
                })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2:
                result = _a.sent();
                if ('statusCode' in result && result.statusCode !== 200) {
                    throw result;
                }
                return [2 /*return*/, result];
        }
    });
}); };
var fetchPreviewInvoice = function (apiKey, data) { return __awaiter(_this$1, void 0, void 0, function () {
    var url, response, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = URLS.INVOICE_PREVIEW + "?" + qs.stringify(data);
                return [4 /*yield*/, fetch(url, {
                        method: METHODS.GET,
                        headers: getAuthHeaders(apiKey)
                    })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2:
                result = _a.sent();
                if ('statusCode' in result && result.statusCode !== 200) {
                    throw result;
                }
                return [2 /*return*/, result];
        }
    });
}); };
var updateSubscription = function (apiKey, id, data) { return __awaiter(_this$1, void 0, void 0, function () {
    var response, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch(URLS.SUBSCRIPTIONS + "/" + id, {
                    method: METHODS.PUT,
                    headers: getAuthHeaders(apiKey),
                    body: JSON.stringify(data)
                })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2:
                result = _a.sent();
                if ('statusCode' in result && result.statusCode !== 200) {
                    throw result;
                }
                return [2 /*return*/, result];
        }
    });
}); };
var reportUsage = function (apiKey, data) { return __awaiter(_this$1, void 0, void 0, function () {
    var response, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch(URLS.USAGE, {
                    method: METHODS.POST,
                    headers: getAuthHeaders(apiKey),
                    body: JSON.stringify(data)
                })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2:
                result = _a.sent();
                if ('statusCode' in result && result.statusCode !== 200) {
                    throw result;
                }
                return [2 /*return*/, result];
        }
    });
}); };
var fetchUsage = function (apiKey, data) { return __awaiter(_this$1, void 0, void 0, function () {
    var url, response, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = URLS.USAGE + "?" + qs.stringify(data);
                return [4 /*yield*/, fetch(url, {
                        method: METHODS.GET,
                        headers: getAuthHeaders(apiKey)
                    })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2:
                result = _a.sent();
                if ('statusCode' in result && result.statusCode !== 200) {
                    throw result;
                }
                return [2 /*return*/, result];
        }
    });
}); };

var _this$2 = undefined;
var checkoutAction = (function (configProps) {
    var api_key = configProps.api_key, isSubmitting = configProps.isSubmitting, setIsSubmitting = configProps.setIsSubmitting, setError = configProps.setError, configStripe = configProps.stripe;
    return function (callProps, stripe) { return __awaiter(_this$2, void 0, void 0, function () {
        var ctxStripe, data, response, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    ctxStripe = stripe || configStripe;
                    if (!ctxStripe) {
                        console.error('Stripe not present - ensure you have passed a valid API key within initialization or have passed your own Stripe instance to this call.');
                        return [2 /*return*/];
                    }
                    if (isSubmitting) {
                        console.warn('Checkout request in progress');
                        return [2 /*return*/];
                    }
                    data = getCheckoutData(configProps, callProps);
                    setIsSubmitting(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, createSession(api_key, data)];
                case 2:
                    response = _a.sent();
                    if ('id' in response) {
                        ctxStripe.redirectToCheckout({
                            sessionId: response.id
                        });
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    setError(err_1);
                    return [3 /*break*/, 4];
                case 4:
                    setIsSubmitting(false);
                    return [2 /*return*/];
            }
        });
    }); };
});

var _this$3 = undefined;
var previewInvoiceAction = (function (configProps) {
    var api_key = configProps.api_key, isSubmitting = configProps.isSubmitting, setIsSubmitting = configProps.setIsSubmitting, setError = configProps.setError;
    return function (callProps) { return __awaiter(_this$3, void 0, void 0, function () {
        var previewInvoiceData, previewInvoice, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isSubmitting) {
                        console.warn('Preview invoice in progress');
                        return [2 /*return*/];
                    }
                    previewInvoiceData = getPreviewInvoiceData(configProps, callProps);
                    setIsSubmitting(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, fetchPreviewInvoice(api_key, previewInvoiceData)];
                case 2:
                    previewInvoice = _a.sent();
                    setIsSubmitting(false);
                    return [2 /*return*/, previewInvoice];
                case 3:
                    err_1 = _a.sent();
                    setError(err_1);
                    return [3 /*break*/, 4];
                case 4:
                    setIsSubmitting(false);
                    return [2 /*return*/];
            }
        });
    }); };
});

var _this$4 = undefined;
var updateSubscriptionAction = (function (configProps) {
    var api_key = configProps.api_key, isSubmitting = configProps.isSubmitting, setIsSubmitting = configProps.setIsSubmitting, setError = configProps.setError;
    return function (callProps) { return __awaiter(_this$4, void 0, void 0, function () {
        var _a, id, data, subscription, err_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (isSubmitting) {
                        console.warn('Preview invoice in progress');
                        return [2 /*return*/];
                    }
                    _a = getUpdateSubscriptionData(configProps, callProps), id = _a.id, data = __rest(_a, ["id"]);
                    setIsSubmitting(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, updateSubscription(api_key, id, data)];
                case 2:
                    subscription = _b.sent();
                    setIsSubmitting(false);
                    return [2 /*return*/, subscription];
                case 3:
                    err_1 = _b.sent();
                    setError(err_1);
                    return [3 /*break*/, 4];
                case 4:
                    setIsSubmitting(false);
                    return [2 /*return*/];
            }
        });
    }); };
});

var _this$5 = undefined;
var billingAction = (function (configProps) {
    var api_key = configProps.api_key, isSubmitting = configProps.isSubmitting, setIsSubmitting = configProps.setIsSubmitting, setError = configProps.setError;
    return function (callProps) { return __awaiter(_this$5, void 0, void 0, function () {
        var billingData, billingSession, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isSubmitting) {
                        console.warn('Billing request in progress');
                        return [2 /*return*/];
                    }
                    billingData = getBillingData(configProps, callProps);
                    if (!billingData.customer) {
                        console.error('A valid customer id is required to start a billing portal session');
                        return [2 /*return*/];
                    }
                    setIsSubmitting(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, createBilling(api_key, billingData)];
                case 2:
                    billingSession = _a.sent();
                    if ('url' in billingSession) {
                        window.location.href = billingSession.url;
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    setError(err_1);
                    return [3 /*break*/, 4];
                case 4:
                    setIsSubmitting(false);
                    return [2 /*return*/];
            }
        });
    }); };
});

var _this$6 = undefined;
var fetchDataAction = (function (configProps) {
    var api_key = configProps.api_key, loading = configProps.loading, setLoading = configProps.setLoading, setValues = configProps.setValues, setMetadata = configProps.setMetadata, setError = configProps.setError, fetchConfigProps = __rest(configProps, ["api_key", "loading", "setLoading", "setValues", "setMetadata", "setError"]);
    return function (props) { return __awaiter(_this$6, void 0, void 0, function () {
        var configData, response, data, metadata, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(!loading || (props && props.force))) return [3 /*break*/, 5];
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    configData = getFetchConfigData(fetchConfigProps);
                    return [4 /*yield*/, fetchConfig(api_key, configData)];
                case 2:
                    response = _a.sent();
                    if ('data' in response) {
                        data = response.data, metadata = __rest(response, ["data"]);
                        setValues(data);
                        setMetadata(metadata);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    setError(err_1);
                    return [3 /*break*/, 4];
                case 4:
                    setLoading(false);
                    _a.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); };
});

var _this$7 = undefined;
var reportUsageAction = (function (configProps) {
    var api_key = configProps.api_key, isSubmitting = configProps.isSubmitting, setIsSubmitting = configProps.setIsSubmitting, setError = configProps.setError;
    return function (callProps) { return __awaiter(_this$7, void 0, void 0, function () {
        var data, usageRecord, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isSubmitting) {
                        console.warn('Report usage in progress');
                        return [2 /*return*/];
                    }
                    data = getReportUsageData(configProps, callProps);
                    setIsSubmitting(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, reportUsage(api_key, data)];
                case 2:
                    usageRecord = _a.sent();
                    setIsSubmitting(false);
                    return [2 /*return*/, usageRecord];
                case 3:
                    err_1 = _a.sent();
                    setError(err_1);
                    return [3 /*break*/, 4];
                case 4:
                    setIsSubmitting(false);
                    return [2 /*return*/];
            }
        });
    }); };
});

var _this$8 = undefined;
var fetchUsageAction = (function (configProps) {
    var api_key = configProps.api_key, isSubmitting = configProps.isSubmitting, setIsSubmitting = configProps.setIsSubmitting, setError = configProps.setError;
    return function (callProps) { return __awaiter(_this$8, void 0, void 0, function () {
        var data, usageSummary, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isSubmitting) {
                        console.warn('Fetch usage in progress');
                        return [2 /*return*/];
                    }
                    data = getFetchUsageData(configProps, callProps);
                    setIsSubmitting(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, fetchUsage(api_key, data)];
                case 2:
                    usageSummary = _a.sent();
                    setIsSubmitting(false);
                    return [2 /*return*/, usageSummary];
                case 3:
                    err_1 = _a.sent();
                    setError(err_1);
                    return [3 /*break*/, 4];
                case 4:
                    setIsSubmitting(false);
                    return [2 /*return*/];
            }
        });
    }); };
});

var checkout = checkoutAction;
var previewInvoice = previewInvoiceAction;
var updateSubscription$1 = updateSubscriptionAction;
var billing = billingAction;
var fetchData = fetchDataAction;
var reportUsage$1 = reportUsageAction;
var fetchUsage$1 = fetchUsageAction;

var checkoutAdd = function (props) {
    return function (data) {
        var updatedValues = lodash.clone(props.values);
        var priceId = typeof data === 'string' ? data : data.price.id;
        var checkoutItems = updatedValues.form.checkout.items;
        var priceIndex = updatedValues.form.checkout.items.findIndex(function (_a) {
            var id = _a.price.id;
            return id === priceId;
        });
        if (priceIndex === -1) {
            /**
             * Add the price to checkout items
             * - Handle single string price id being passed
             * - Else add full CheckoutItem data shape
             */
            checkoutItems.push(typeof data === 'string'
                ? { price: { id: data } }
                : data);
            /**
             * Update the checkout items
             */
            lodash.set(updatedValues, 'form.checkout.items', checkoutItems);
            props.setValues(updatedValues);
        }
        else {
            console.warn('Already present in checkout');
        }
        return updatedValues;
    };
};
var checkoutRemove = function (props) {
    return function (priceId) {
        var updatedValues = lodash.clone(props.values);
        var checkoutItems = updatedValues.form.checkout.items;
        var priceIndex = updatedValues.form.checkout.items.findIndex(function (_a) {
            var id = _a.price.id;
            return id === priceId;
        });
        if (priceIndex >= 0) {
            /**
             * Remove the price from checkout items
             */
            checkoutItems.splice(priceIndex, 1);
            /**
             * Update the form checkout items
             */
            lodash.set(updatedValues, 'form.checkout.items', checkoutItems);
            props.setValues(updatedValues);
        }
        else {
            console.warn('Not present in checkout');
        }
        return updatedValues;
    };
};

var _a$1;
var createUseContext = function (contextProviderWrapperCreator) {
    var Context = React.createContext(null);
    var useContext = function () { return React.useContext(Context); };
    var ContextProvider;
    if (typeof contextProviderWrapperCreator === 'function') {
        ContextProvider = contextProviderWrapperCreator(Context.Provider);
    }
    else {
        ContextProvider = Context.Provider;
    }
    return {
        Context: Context,
        ContextProvider: ContextProvider,
        ContextConsumer: Context.Consumer,
        useContext: useContext
    };
};
var WithStripeContext = function (_a) {
    var children = _a.children, Provider = _a.Provider, providerValue = _a.providerValue, setStripe = _a.setStripe, ready = _a.ready;
    /**
     * Once Stripe is initialized cache the instance
     */
    var stripe = reactStripeJs.useStripe();
    React.useEffect(function () {
        if (stripe && !ready) {
            setStripe(stripe);
        }
    }, [stripe, ready]);
    return React.createElement(Provider, { value: providerValue }, children);
};
var StripeElementContainer = function (props) {
    var promise = React.useMemo(function () { return stripeJs.loadStripe(props.clientKey); }, []);
    return (React.createElement(reactStripeJs.Elements, { stripe: promise },
        React.createElement(WithStripeContext, { setStripe: props.setStripe, ready: props.ready, providerValue: props.providerValue, Provider: props.Provider }, props.children)));
};
var PriceBlocsContext = (_a$1 = createUseContext(function (Provider) {
    return function (contextProps) {
        var children = contextProps.children, api_key = contextProps.api_key, initialValues = contextProps.values, success_url = contextProps.success_url, cancel_url = contextProps.cancel_url, return_url = contextProps.return_url, initialConfig = contextProps.config, fetchConfigProps = __rest(contextProps, ["children", "api_key", "values", "success_url", "cancel_url", "return_url", "config"]);
        var config = getConfig(initialConfig);
        var _a = React.useState(), metadata = _a[0], setMetadata = _a[1];
        var _b = React.useState(initialValues), values = _b[0], setValues = _b[1];
        var _c = React.useState(false), loading = _c[0], setLoading = _c[1];
        var _d = React.useState(false), initialFetch = _d[0], setInitialFetch = _d[1];
        var _e = React.useState(null), stripe = _e[0], setStripe = _e[1];
        var ready = Boolean(stripe);
        var _f = React.useState(false), isSubmitting = _f[0], setIsSubmitting = _f[1];
        var _g = React.useState(null), error = _g[0], setError = _g[1];
        var clientKey = values && values.admin && values.admin.clientKey;
        var setFieldValue = function (path, value) {
            var updatedValues = lodash.clone(values);
            lodash.set(updatedValues, path, value);
            setValues(updatedValues);
        };
        var customer = values ? values.customer : null;
        var customerId = contextProps.customer;
        var customerEmail = contextProps.customer_email;
        var email = contextProps.email;
        /**
         * Fetch values based on provided fetchConfigProps
         * - Note: will also fetch corresponding products and their metadata
         */
        var refetch = fetchData(__assign({ setLoading: setLoading,
            setValues: setValues,
            setMetadata: setMetadata,
            setError: setError,
            api_key: api_key, customer: customerId, customer_email: customerEmail, email: email, loading: loading,
            success_url: success_url,
            cancel_url: cancel_url }, fetchConfigProps));
        /**
         * Fetch values on mount if
         * - no values
         * - not loading
         * - no error
         * - initial fetch has not happened
         * - initial_fetch
         */
        React.useEffect(function () {
            var preventRequest = Boolean(loading || error);
            var makeInitialFetch = !values && !preventRequest && !initialFetch && config.fetch.on_mount;
            if (makeInitialFetch) {
                setInitialFetch(true);
                refetch();
            }
        }, [values, loading, error, initialFetch, config.fetch.on_mount]);
        /**
         * Auto-refetch if
         * - any of the customer references have changed
         * - at least one is present
         * - no errors
         */
        React.useEffect(function () {
            var hasCustomerRef = Boolean(customerId || customerEmail || email);
            var makeOnCustomerChangeFetch = hasCustomerRef && !error && config.fetch.on_customer_change;
            if (makeOnCustomerChangeFetch) {
                refetch({ force: true });
            }
        }, [customerId, customerEmail, email, config.fetch.on_customer_change]);
        var commonProps = {
            api_key: api_key,
            customer: customer,
            isSubmitting: isSubmitting,
            setIsSubmitting: setIsSubmitting,
            setError: setError
        };
        var providerValue = {
            ready: ready,
            stripe: stripe,
            loading: loading,
            isSubmitting: isSubmitting,
            setValues: setValues,
            setFieldValue: setFieldValue,
            setError: setError,
            refetch: refetch,
            checkout: checkout(__assign({}, commonProps, { stripe: stripe,
                success_url: success_url,
                cancel_url: cancel_url,
                return_url: return_url,
                metadata: metadata })),
            billing: billing(__assign({}, commonProps, { return_url: return_url })),
            checkoutAdd: checkoutAdd({ setValues: setValues, values: values }),
            checkoutRemove: checkoutRemove({ setValues: setValues, values: values }),
            previewInvoice: previewInvoice(__assign({}, commonProps, { values: values })),
            updateSubscription: updateSubscription$1(__assign({}, commonProps, { values: values })),
            reportUsage: reportUsage$1(commonProps),
            fetchUsage: fetchUsage$1(commonProps)
        };
        if (values) {
            providerValue.values = values;
        }
        if (metadata) {
            providerValue.metadata = metadata;
        }
        if (error) {
            providerValue.error = error;
        }
        var content = typeof children === 'function' ? children(providerValue) : children;
        /**
         * Client key is required to initialize the Stripe container
         */
        return clientKey ? (React.createElement(StripeElementContainer, { ready: ready, setStripe: setStripe, clientKey: clientKey, providerValue: providerValue, Provider: Provider }, content)) : (React.createElement(Provider, { value: providerValue }, content));
    };
}), _a$1.Context), PriceBlocs = _a$1.ContextProvider, usePriceBlocsContext = _a$1.useContext;
/**
 * Hooks
 */
var useActiveProductPrice$1 = useActiveProductPrice;
var useSubscriptionItemForPrice$1 = useSubscriptionItemForPrice;
var useEntitlement$1 = useEntitlement;
var useFeature$1 = useFeature;
var useCheckoutCart$1 = useCheckoutCart;
var useGoodStandingSubscriptions$1 = useGoodStandingSubscriptions;
var usePreviewInvoice$1 = usePreviewInvoice;
/**
 * Utils
 */
var getGoodStandingSubscriptions$1 = getGoodStandingSubscriptions;
var getActiveProductPrice$1 = getActiveProductPrice;
var getProductFeatures$1 = getProductFeatures;
var getProductsFeaturesTable$1 = getProductsFeaturesTable;
/**
 * Constants
 */
var RECURRING_INTERVALS$1 = RECURRING_INTERVALS;
var INTERVAL_LABELS_MAP$1 = INTERVAL_LABELS_MAP;
var INTERVAL_SHORTHAND_MAP$1 = INTERVAL_SHORTHAND_MAP;

exports.INTERVAL_LABELS_MAP = INTERVAL_LABELS_MAP$1;
exports.INTERVAL_SHORTHAND_MAP = INTERVAL_SHORTHAND_MAP$1;
exports.PriceBlocs = PriceBlocs;
exports.PriceBlocsContext = PriceBlocsContext;
exports.RECURRING_INTERVALS = RECURRING_INTERVALS$1;
exports.getActiveProductPrice = getActiveProductPrice$1;
exports.getGoodStandingSubscriptions = getGoodStandingSubscriptions$1;
exports.getProductFeatures = getProductFeatures$1;
exports.getProductsFeaturesTable = getProductsFeaturesTable$1;
exports.useActiveProductPrice = useActiveProductPrice$1;
exports.useCheckoutCart = useCheckoutCart$1;
exports.useEntitlement = useEntitlement$1;
exports.useFeature = useFeature$1;
exports.useGoodStandingSubscriptions = useGoodStandingSubscriptions$1;
exports.usePreviewInvoice = usePreviewInvoice$1;
exports.usePriceBlocsContext = usePriceBlocsContext;
exports.useSubscriptionItemForPrice = useSubscriptionItemForPrice$1;
//# sourceMappingURL=index.js.map
